import { IButtonStyles, ILinkStyles, IStackStyles, IStyle, ITextStyles } from '@fluentui/react';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { INoMenuErrorStyles } from './INoMenuErrorStyles';

export class CorptaxThemeNoMenuErrorStyles implements INoMenuErrorStyles {
    constructor(private theme: ICorptaxTheme) {}

    get orderedListStyles(): IStyle {
        return {
            'li:not(:last-child)': {
                marginBottom: 15,
            },
        };
    }

    get stackStyles(): IStackStyles {
        return { root: { padding: '10px' } };
    }

    get unableToLoadImgStyles(): IStyle {
        return { height: 100 };
    }

    get largeMessageStyles(): ITextStyles {
        return { root: { color: this.theme.semanticColors.infoIcon } };
    }

    get refreshButtonStyles(): IButtonStyles {
        return { root: { padding: 0, height: 28, color: this.theme.extendedPalette.accentDarker } };
    }

    get refreshTextStyles(): ITextStyles {
        return { root: { paddingLeft: 5 } };
    }

    get customerServiceLink(): ILinkStyles {
        return { root: { color: this.theme.extendedPalette.accentDarker } };
    }
}
